// eslint-disable-next-line no-shadow
export enum PricingModelType {
  ONE_ON_ONE = "one-on-one",
  SELF_STUDY = "self-study",
}

export const PRICINGMODEL_OBJ = {
  name: {
    label: "Name",
    type: "text",
    required: true,
    maxLength: 64,
  },
  code: {
    label: "Code",
    type: "text",
    required: true,
    maxLength: 16,
  },
  description: {
    label: "Description",
    type: "text",
    required: true,
    maxLength: 512,
  },
  team: {
    label: "Team",
    required: false,
    maxLength: 64,
  },
  type: {
    label: "Pricing type",
    required: true,
    default: PricingModelType.ONE_ON_ONE,
    options: [PricingModelType.ONE_ON_ONE, PricingModelType.SELF_STUDY],
  },
};

export interface PricingModelCompany {
  id: string;
  name: string;
}

export interface PricingModelTeam {
  id: string;
  name: string;
  company: PricingModelCompany | null;
}

export interface PricingModelStudent {
  id: string;
  firstname: string;
  lastname: string;
  email: string;
  created: string;
}

export interface PricingModel {
  id: string;
  name: string;
  code: string;
  description: string;
  team: PricingModelTeam | null;
  url: string;
  currency: string;
  students: PricingModelStudent[];
  items: PricingModelItem[];
  is_default?: boolean;
  type: PricingModelType;
}

export const PRICINGMODELITEM_OBJ = {
  name: {
    label: "Item Name",
    type: "text",
    required: true,
    maxLength: 64,
  },
  description: {
    label: "Item Description",
    type: "text",
    required: true,
    maxLength: 512,
  },
  number: {
    label: "Number of Lessons",
    type: "number",
    required: true,
    minValue: 1,
    maxValue: 99, //For now I don't think we'll have a package for an individual with more than 99 hours in it.
  },
  price: {
    label: "Price of Item",
    type: "number",
    required: true,
    minValue: 1,
    maxValue: 9999,
  },
  length: {
    label: "Subscription length",
    type: "number",
    required: true,
    minValue: 1,
    maxValue: 365, // Annual subscription is maximum for now.
  },
};

export interface SelfStudyPricingModelItem {
  id?: string;
  name: string;
  description: string;
  length: number | null;
  price: number | null;
  currency: string | null;
}

export interface OneOnOnePricingModelItem {
  id?: string;
  name: string;
  description: string;
  number: number | null;
  price: number | null;
  currency: string | null;
}

export interface CreatePurchaseIntentResponse {
  client_secret: string;
  status: string;
}

export const isOneOnOneItem = (
  item: PricingModelItem
): item is OneOnOnePricingModelItem => {
  return (item as OneOnOnePricingModelItem).number !== undefined;
};

export const isSelfStudyItem = (
  item: PricingModelItem
): item is SelfStudyPricingModelItem => {
  return (item as SelfStudyPricingModelItem).length !== undefined;
};

export const emptyOneOnOneItem = () => {
  return { name: "", description: "", number: null, price: null, currency: null };
};

export const emptySelfStudyItem = () => {
  return { name: "", description: "", length: null, price: null, currency: null };
};

export function periodToString(period: number) {
  if (period === 30 || period === 31) {
    return "month";
  }
  if (period === 365) {
    return "year";
  }

  return `${period} days`;
}

export type PricingModelItem = SelfStudyPricingModelItem | OneOnOnePricingModelItem;
